import { render, staticRenderFns } from "./AddFreeBoxTime.vue?vue&type=template&id=0ac66a0a&scoped=true&"
import script from "./AddFreeBoxTime.vue?vue&type=script&lang=js&"
export * from "./AddFreeBoxTime.vue?vue&type=script&lang=js&"
import style0 from "./AddFreeBoxTime.vue?vue&type=style&index=0&id=0ac66a0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac66a0a",
  null
  
)

export default component.exports